import Student from './student.js';

let $ = window.jQuery;

class Order{
    students = [];
    parents = [];
    deposit = 100;
    total = 0;
    totalToPay = 0;
    reservationTotal = 0;
    imageRightsWhatsapp = 0;
    imageRightsPromotion = 0;
    imageRightsSocialMedia = 0;
    legalAuthorization = 0;
    healthRequirements = 0;
    privacyPoliciy = 1;
    paymentMethod = null;
    isPartialDeposit = false;
    couponDiscountCode = "";

    constructor(parents, deposit, total, totalToPay, reservationTotal, imageRightsWhatsapp, imageRightsPromotion, imageRightsSocialMedia, legalAuthorization, healthRequirements, paymentMethod, isPartialDeposit, couponDiscountCode){
        this.parents = parents;
        this.deposit = deposit;
        this.total = total;
        this.totalToPay = totalToPay;
        this.reservationTotal = reservationTotal;
        //this.imageRightsWhatsapp = imageRightsWhatsapp ? 1 : 0;  
        //this.imageRightsPromotion = imageRightsPromotion ? 1 : 0;
        //this.imageRightsSocialMedia = imageRightsSocialMedia ? 1 : 0;
        //this.legalAuthorization = legalAuthorization ? 1 : 0;
        this.imageRightsWhatsapp = Number(imageRightsWhatsapp) === 1 ? 1 : 0;
        this.imageRightsPromotion = Number(imageRightsPromotion) === 1 ? 1 : 0;
        this.imageRightsSocialMedia = Number(imageRightsSocialMedia) === 1 ? 1 : 0;        
        this.legalAuthorization = Number(legalAuthorization) === 1 ? 1 : 0;        
        this.healthRequirements = healthRequirements ? 1 : 0;
        this.paymentMethod = paymentMethod;
        this.isPartialDeposit = isPartialDeposit;
        this.couponDiscountCode = couponDiscountCode;
    }

    addStudent(student){
        if (!(student in this.students) && student instanceof Student){
            this.students.push(student);
        }
    }

    removeStudent(student){
        if (student in this.students) {
            this.students.splice(this.students.indexOf(student), 1);
        }
    }

    send(){
        return new Promise((resolve, reject) => {
            if(!this.paymentMethod){
                reject("Missing payment method");
            }

            let orderData = this.data();
            
            let formdata = new FormData();
            formdata.append('action', 'safa_create_order');
            formdata.append('order', JSON.stringify(orderData));

            //Ficheros
            for(let s = 0; s < orderData.students.length; s++){
                let student = orderData.students[s];
                if(student.catsalut){
                    formdata.append(`student_${s}_catsalut`, student.catsalut);
                }

                if(student.vaccinationBook){
                    formdata.append(`student_${s}_vaccinationBook`, student.vaccinationBook);
                }
            }

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: formdata,
                contentType: false,
                processData: false,
                success: function(response){
                    resolve(response);
                },
                error: function(response){
                    reject(response);
                }
            });
        });
    }

    data(){
        return {
            order: {
                deposit: this.deposit,
                total: this.total,
                totalToPay: this.totalToPay,
                reservationTotal: this.reservationTotal,
                imageRightsWhatsapp: this.imageRightsWhatsapp,
                imageRightsPromotion: this.imageRightsPromotion,
                imageRightsSocialMedia: this.imageRightsSocialMedia,
                legalAuthorization: this.legalAuthorization,
                healthRequirements: this.healthRequirements,
                privacyPoliciy: this.privacyPoliciy,
                paymentMethod: this.paymentMethod,
                isPartialDeposit: !!this.isPartialDeposit ? 1 : 0,
                couponDiscountCode: this.couponDiscountCode
            },
            parents: this.parents,
            students: this.students.map(student => student.data())
        };
    }
}

export default Order;